import { StyleSheet } from "aphrodite";

const styles = StyleSheet.create({
  mainGrid: {
    padding: "0px",
    margin: "0px",
    //minHeight: "90vh",
    minHeight: "calc(100vh - 120px)",
  },
  sideStyle: {
    borderRightWidth: "20px",
    borderRightStyle: "solid",
    borderImage: "linear-gradient(#2156a4, #32a6c4e3) 30"
  },

  //right div styles

  header: {
    display: "flex",
    alignItems: "center",
    borderBottom: "2px solid #76787a",
    paddingBottom: "10px",
    margin: "10px 0px 10px 0px",
    color: "black",
    fontSize: "18px",
    //fontFamily: "sans-sarif"
  },
  formGroupStyles: {
    display: "flex",
    verticalAlign: "middle",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 0px 8px 10px",
    borderBottom: "1px solid #ccc",
    margin: "1em 0em",
    gap: "12px",
    "@media (max-width: 767.98px)": {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  formGroupStylesNew: {
    display: "flex",
    verticalAlign: "middle",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 0px 8px 10px",
    //borderBottom: "1px solid #ccc",
    margin: "1em 0em",
    gap: "12px",
    "@media (max-width: 767.98px)": {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  settingActionButtons: {
    textAlign: "right",
    flexShrink: 0,
  },
  settingSelectDropdown: {
    width: "100%",
    maxWidth: "220px",
    flexShrink: 0,
    "@media (max-width: 767.98px)": {
      maxWidth: "100%",
    },
  },
  name: {
    fontSize: "16px",
    marginBottom: "5px",
    color: "#76787a",
    marginTop: "4px",
    float: "left",
  },
  role: {
    fontSize: "14px",
    color: "#76787a",
  },
  labels: {
    fontSize: "14px",
    color: "#76787a",
    marginLeft: "3%",
    textTransform: "uppercase"
  },
  valueLabels: {
    fontSize: "14px",
    color: "black",
    textTransform: "capitalize",
    marginBottom: "1em"
  },
  settingLabels: {
    fontSize: "16px",
    color: "black",
    textTransform: "capitalize",
  },
  settingCardLabels: {
    flex: "1 1 0",
    minWidth: 0,
  },
  disabledLabels: {
    fontSize: "16px",
    color: "grey",
    textTransform: "capitalize"
  },
  infoLabels: {
    fontSize: "15px",
    color: "#e55329f2",
    textTransform: "initial"
  },
  subLabels: {
    fontSize: "14px",
    color: "#2a2828",
    textTransform: "initial"
  },
  editButtonStyles: {
    borderRadius: "20px",
    fontSize: "14px",
    textTransform: "capitalize",
    marginRight: "1.5em",
    backgroundColor: "grey",
    borderColor: "white"
  },
  updateButtonStyles: {
    borderRadius: "20px",
    //fontSize: "10px",
    textTransform: "capitalize",
    //marginTop: "1em"
  },
  cardHeaderStyle : {
    padding: "0px",
    borderBottom: "none",
    backgroundColor: "#ffffff00"
  }

});

export default styles;
